module.exports = " <div class=vc-page transition=app> <header-bar> <icon-button slot=left @click=showNav icon=menu></icon-button> <span>Vue Carbon</span> </header-bar> <scroll-view v-ref:scroller> <content-block> Vue Carbon 是基于 vue 开发的material design ui 库。 </content-block> <template v-for=\"group in menus\"> <content-title> {{group.title}} </content-title> <list> <item-cell link v-link=menu.link v-for=\"menu in group.children\"> <item-media> <i class=logo>C</i> </item-media> <item-title> {{menu.title}} </item-title> </item-cell> </list> </template> </scroll-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-examples/views/home.vue
 ** module id = 394
 ** module chunks = 1
 **/